var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    {
      staticClass: "col-12 d-flex flex-column filter-field-set",
      class: { "mt-3": !_vm.allowSearch },
    },
    [
      _vm.allowSearch
        ? _c("div", { staticClass: "sticky-top" }, [
            _c(
              "div",
              { staticClass: "right-inner-addon mb-4" },
              [
                _c("icon", { attrs: { name: "search" } }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.searchString,
                      expression: "searchString",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control search-inactive-clients",
                  attrs: {
                    id: "search-agents",
                    type: "search",
                    placeholder: _vm.searchPlaceholder,
                    autocomplete: "off",
                  },
                  domProps: { value: _vm.searchString },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchString = $event.target.value.trim()
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "search-agents", hidden: "" } }, [
                  _vm._v(_vm._s(_vm.searchPlaceholder)),
                ]),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.filteredOptions, function (option, index) {
        return _c(
          "div",
          { key: option.key, staticClass: "pretty p-icon p-smooth mt-0 mb-3" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.valueModel,
                  expression: "valueModel",
                },
              ],
              staticClass: "form-check-input",
              attrs: {
                id: "filter-" + option.key + "-" + index,
                type: "checkbox",
              },
              domProps: {
                value: option.value,
                checked: Array.isArray(_vm.valueModel)
                  ? _vm._i(_vm.valueModel, option.value) > -1
                  : _vm.valueModel,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.valueModel,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = option.value,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.valueModel = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.valueModel = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.valueModel = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "state p-primary" }, [
              _c("i", { staticClass: "icon fa fa-check" }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "clickable text-gray text-capitalize",
                  attrs: { for: "filter-" + option.key + "-" + index },
                },
                [_vm._v("\n        " + _vm._s(option.name) + "\n      ")]
              ),
            ]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }